import React from 'react'
import {connect} from 'react-redux'
import {compose, lifecycle} from 'recompose'
import WithAjax from '../common/helpers/WithAjax'
import TabList from '../common/helpers/TabList'
import {setJumbotronTitle} from '../../actions/common'
import {clearVoiceTest, fetchVoiceTestOverviewSuccess} from '../../actions/pages/voice-test-page'

import VoiceTestOverview from './VoiceTestOverview'
import VoiceTestCriteria from './VoiceTestCriteria'
import VoiceTestCandidates from './VoiceTestCandidates'
import History from './History'

const mapStateToProps = (state, ownProps) => ({
  overview: state.voiceTestPage.overview,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle: title => dispatch(setJumbotronTitle(title)),
  clearVoiceTest() { dispatch(clearVoiceTest()) },
  fetchVoiceTestOverviewSuccess(overview) { dispatch(fetchVoiceTestOverviewSuccess(overview)) }
})

const VoiceTestEdit = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      let id = parseInt(this.props.match.params.id, 10);

      if (!Number.isInteger(id)){
        return;
      }

      this.setState({
        contentItems: [
          {
            label: 'Overview',
            link: 'overview',
            content: <VoiceTestOverview voiceTestId={id} />
          },
          {
            label: 'Criteria',
            link: 'criteria',
            content: <VoiceTestCriteria voiceTestId={id} />
          },
          {
            label: 'Candidates',
            link: 'candidates',
            content: <VoiceTestCandidates voiceTestId={id} />
          },
          {
            label: 'History',
            link: 'history',
            content: <History voiceTestId={id} />
          }
        ]
      });

      this.fetchVoiceTest();
    },
    componentDidUpdate(prevProps) {
      if (this.props.overview === null && !this.props.isLoading) {
        this.fetchVoiceTest();
      }
    },
    fetchVoiceTest() {
      let id = parseInt(this.props.match.params.id, 10);

      let url = 'voicetests/' + id;

      this.props.clearVoiceTest();
      this.props.ajax.get(url, true, (data) => {
        let jumbotronContent = [
          {label: data.ProductionTitle, url: '/productions/' + data.ProductionId + '/overview'},
          {label: 'Voice tests', url: '/productions/' + data.ProductionId + '/voiceTests' },
          {label: data.SkillTypeLabel}
        ]
        this.props.setJumbotronTitle(jumbotronContent);

        this.props.fetchVoiceTestOverviewSuccess(data);
      });
    }
  })
)

export default WithAjax(VoiceTestEdit(TabList))
